/* _customled-cart-reviews.js  —  OWNED (Maranello, Cart M1.13)
 * ---------------------------------------------------------------------------
 * In the cart reviews CAROUSEL (sections/customled-cart-reviews.liquid), replace
 * each card's REVIEW HEADLINE ("Parfait", etc.) with the PRODUCT NAME. Stamped's
 * carousel renders the review title in a full-width slot (.stamped-reviews-title)
 * but the product name only in a cramped ~80px float column
 * (.stamped-reviews-product-title, which our CSS hides). Merchant wants the
 * product name as the prominent full-width title instead of the review headline.
 *
 * CSS can't move text between elements, so we copy the product-name text into the
 * title slot once the carousel renders (as PLAIN text — the title's href is dropped
 * since the product is already in the cart, so the link would be redundant). The
 * product name is read from the hidden .stamped-reviews-product-title (display:none
 * keeps it in the DOM/readable).
 *
 * Robustness: cards render once into a horizontal scroll strip (no re-render on
 * arrow nav), so a one-time pass + a short-lived MutationObserver (to catch the
 * async Stamped render) covers them. Each title is marked data-cl-swapped to avoid
 * re-processing / mutation loops. No-ops gracefully if Stamped's classes change.
 * Loaded only on the cart template (see _customled-stylesheets.liquid).
 */
(function () {
  function swap() {
    var root = document.querySelector('.customled-cart-reviews #stamped-reviews-widget');
    if (!root) return;
    var titles = root.querySelectorAll('.stamped-reviews-title');
    for (var i = 0; i < titles.length; i++) {
      var titleEl = titles[i];
      if (titleEl.getAttribute('data-cl-swapped')) continue;
      var titleLink = titleEl.querySelector('.stamped-reviews-link');
      var card = titleEl.closest('.block') || titleEl.parentNode;
      var prod = card ? card.querySelector('.stamped-reviews-product-title .stamped-reviews-link') : null;
      var name = prod ? (prod.textContent || '').trim() : '';
      if (titleLink && name) {
        titleLink.textContent = name;
        // No hyperlink: the product is already in the cart, so the title is plain
        // text. Dropping href makes the <a> non-interactive (no pointer, not clickable)
        // while keeping its styling.
        titleLink.removeAttribute('href');
        titleLink.style.cursor = 'default';
        // Same rationale for the thumbnail link — keep the whole card non-interactive
        // so nothing pulls the shopper out of checkout.
        if (card) {
          var imgA = card.querySelector('.stamped-reviews-image a');
          if (imgA) { imgA.removeAttribute('href'); imgA.style.cursor = 'default'; }
        }
        titleEl.setAttribute('data-cl-swapped', '1');
      }
    }
  }
  function init() {
    swap();
    var root = document.querySelector('.customled-cart-reviews') || document.body;
    if (!root || !window.MutationObserver) return;
    var obs = new MutationObserver(function () { swap(); });
    obs.observe(root, { childList: true, subtree: true });
    // The carousel finishes rendering within a few seconds of the lazy Stamped load;
    // stop observing afterward so we don't keep doing work for the page's lifetime.
    setTimeout(function () { obs.disconnect(); }, 30000);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
